import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import AutocompleteField from "../../components/field/AutocompleteField";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "../../hooks/useForm";
import { useGetPersonSelectList } from "../../services/customersService";

export function SelectPersonDialog(props) {
    const { t } = useTranslation();
    const seearchParams = useMemo(()=>{
        const tempSeearchParams = new URLSearchParams();
        if (props.person_ids && props.person_ids.length > 0) {
            tempSeearchParams.set("person_ids", props.person_ids.join(","));
        }
        return tempSeearchParams
    }, props.person_ids)
   
    const { data: personList } = useGetPersonSelectList(seearchParams);
    const { formValue, onChangeAutocompleteFieldWithObjectOptions } = useForm({});

    const handleConfirm = () => {
        props.onConfirm(formValue.person);
    };

    const handleClose = () => {
        props.onClose();
    };

    const hasSelectedPerson = formValue.person;

    return (
        <Dialog open={props.open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t("person.selectPerson")}</DialogTitle>
            <DialogContent>
                <Grid item xs={12}>
                    <AutocompleteField
                        name="person"
                        multiple={false}
                        addNewValue={false}
                        onChange={onChangeAutocompleteFieldWithObjectOptions}
                        options={personList || []}
                        label={t("person.selectPerson")}
                        isObjectOption
                        optionLabelKey="full_name"
                        value={formValue?.person}
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    {t("cancel")}
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    disabled={!hasSelectedPerson}
                >
                    {t("confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
